/**
 * Root component that wraps the entire application.
 *
 * Provides the safe-area shell for iOS notch and home bar handling.
 * Currently mounts the Landing page. As routing is added, this
 * becomes the layout wrapper around a router outlet.
 *
 * Consumed by entrypoints/main.tsx.
 */
import { Landing } from "./landing/Landing";

export function App() {
  return (
    <div className="app-shell flex flex-col">
      <Landing />
    </div>
  );
}
